import React from "react";
import { Form, Modal, Select } from "antd";

type Props = {
  open: boolean;
  folderList: {
    id: number;
    name: string;
  }[];
  onConfirm: (params: { folderId: number }) => void;
  onCancel: () => void;
};

export default function MoveFolder(props: Props) {
  const { open, folderList, onConfirm, onCancel } = props;
  const [form] = Form.useForm();

  const confirm = () => {
    form
      .validateFields()
      .then((values) => {
        onConfirm({ folderId: values.folder });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Modal title="移动至" open={open} onOk={confirm} onCancel={onCancel}>
      <Form form={form}>
        <Form.Item label="移动到" name="folder">
          <Select>
            {folderList.map((folder) => {
              return (
                <Select.Option key={folder.id}>{folder.name}</Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
